'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _keyConstants = require('../utils/keyboard/keyConstants');

var _rafThrottle = require('../../common/utils/lib/rafThrottle');

var _rafThrottle2 = _interopRequireDefault(_rafThrottle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Constants


exports.default = function (DecoratedComponent) {
    var grabScrollDecorator = function (_React$Component) {
        _inherits(grabScrollDecorator, _React$Component);

        function grabScrollDecorator(props) {
            _classCallCheck(this, grabScrollDecorator);

            var _this = _possibleConstructorReturn(this, (grabScrollDecorator.__proto__ || Object.getPrototypeOf(grabScrollDecorator)).call(this, props));

            _this.onKeyDown = function (event) {
                var grabEnabled = _this.state.grabEnabled;

                // If the event

                if (event.keyCode === _keyConstants.KEY_CODES.SPACEBAR && event.target === window.document.body) {
                    // TODO Try to prevent the cursor from hiding when the space bar is pressed
                    event.preventDefault();
                    event.stopPropagation();

                    if (!grabEnabled) {
                        _this.setState({ grabEnabled: true });
                        document.addEventListener('mousedown', _this.bodyMousedown);
                    }
                }
            };

            _this.onKeyUp = function (event) {
                var grabEnabled = _this.state.grabEnabled;


                if (event.keyCode === _keyConstants.KEY_CODES.SPACEBAR && grabEnabled) {
                    _this.setState({ grabEnabled: false, grabbing: false });
                    _this.rafBodyMousemove.cancel();
                    document.removeEventListener('mousedown', _this.bodyMousedown);
                    document.removeEventListener('mousemove', _this.rafBodyMousemove);
                    document.removeEventListener('mouseup', _this.bodyMouseup);
                }
            };

            _this.bodyMousedown = function (event) {
                _this.canvas = _reactDom2.default.findDOMNode(_this);
                _this.mouseX = event.pageX;
                _this.mouseY = event.pageY;
                _this.setState({ grabbing: true });

                document.addEventListener('mouseup', _this.bodyMouseup);
                document.addEventListener('mousemove', _this.rafBodyMousemove);
                event.preventDefault();
                event.stopPropagation();
            };

            _this.bodyMousemove = function (event) {
                _this.canvas.scrollLeft = Math.max((_this.canvas.scrollLeft || 0) + (_this.mouseX - event.pageX), 0);
                _this.canvas.scrollTop = Math.max((_this.canvas.scrollTop || 0) + (_this.mouseY - event.pageY), 0);

                _this.mouseX = event.pageX;
                _this.mouseY = event.pageY;
                event.preventDefault();
                event.stopPropagation();
            };

            _this.rafBodyMousemove = (0, _rafThrottle2.default)(_this.bodyMousemove);

            _this.bodyMouseup = function () {
                _this.setState({ grabbing: false });
                _this.rafBodyMousemove.cancel();
                document.removeEventListener('mousemove', _this.rafBodyMousemove);
                document.removeEventListener('mouseup', _this.bodyMouseup);
                event.preventDefault();
                event.stopPropagation();
            };

            _this.state = {
                grabEnabled: false,
                grabbing: false
            };

            _this.mouseX = 0;
            _this.mouseY = 0;
            return _this;
        }

        _createClass(grabScrollDecorator, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                document.addEventListener('keydown', this.onKeyDown);
                document.addEventListener('keyup', this.onKeyUp);
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                document.removeEventListener('keydown', this.onKeyDown);
                document.removeEventListener('keyup', this.onKeyUp);
            }
        }, {
            key: 'render',
            value: function render() {
                var _state = this.state,
                    grabEnabled = _state.grabEnabled,
                    grabbing = _state.grabbing;


                return _react2.default.createElement(DecoratedComponent, _extends({ grabEnabled: grabEnabled, grabbing: grabbing }, this.props));
            }
        }]);

        return grabScrollDecorator;
    }(_react2.default.Component);

    grabScrollDecorator.propTypes = {};

    return grabScrollDecorator;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/canvas/grabScrollDecorator.js
// module id = 1693
// module chunks = 0